import { IntlShape } from 'react-intl';

export const getCleosStatus = (status: unknown, intl: IntlShape) => {
  const s = typeof status === 'number' ? status : Number(status);
  switch (s) {
    case 1:
      return intl.formatMessage({ id: 'generalValues.statusActive' });
    case 2:
      return intl.formatMessage({ id: 'generalValues.statusPaused' });
    case 3:
      return intl.formatMessage({ id: 'generalValues.statusDiscontinued' });
    default:
      return intl.formatMessage({ id: 'generalValues.unknown' });
  }
};

export const getStatusDropdownItems = (intl: IntlShape) => {
  return [
    {
      label: intl.formatMessage({ id: 'generalValues.statusActive' }),
      value: 1,
    },
    {
      label: intl.formatMessage({ id: 'generalValues.statusPaused' }),
      value: 2,
    },
    {
      label: intl.formatMessage({ id: 'generalValues.statusDiscontinued' }),
      value: 3,
    },
  ];
};
